import type { SxProps } from '@/features/uiKit/sxProps';

const landingSidePadding = '20px';

export const landingContentFrame = {
  width: '100%',
  maxWidth: '1280px',
  boxSizing: 'border-box',
  paddingLeft: landingSidePadding,
  paddingRight: landingSidePadding,
} as const satisfies SxProps;

export const APP_NAME = 'FluencyPal';
